import "./App.css";
import NetworkStatusModal from "./app/components/NetworkStatusModal/NetworkStatusModal";
import Routercomponent from "./app/RouterComponent/Routercomponent";
import { ErrorProvider } from "./app/utils/ErrorContext";
import { ToastProvider } from "./app/utils/ToastContext";
import GlobalErrorModal from "./app/components/GlobalErrorModal/GlobalErrorModal";
import ErrorBoundary from "./app/components/ErrorBoundary/ErrorBoundary";

function App() {
  return (
    <ErrorProvider>
      <ToastProvider>
        <div className="App">
          <NetworkStatusModal />
          <GlobalErrorModal />
          <ErrorBoundary>
            <Routercomponent />
          </ErrorBoundary>
        </div>
      </ToastProvider>
    </ErrorProvider>
  );
}

export default App;
